module.exports = __webpack_public_path__ + "img/code_canadaycmusicacademy.dc036053.png";